import styles from "./BoostRewardsIndicator.module.css";
import boost_x1_orange from "/Expeditions/boost-x1-orange.svg";
import boost_x1point5_orange from "/Expeditions/boost-x1.5-orange.svg";
import boost_x1_gray from "/Expeditions/boost-x1-gray.svg";
import boost_x1_green from "/Expeditions/boost-x1-green.svg";
import boost_x1point5gray from "/Expeditions/boost-x1.5-gray.svg";
import boost_x1point5_green from "/Expeditions/boost-x1.5-green.svg";
import boost_x2_gray from "/Expeditions/boost-x2-gray.svg";
import boost_x2_green from "/Expeditions/boost-x2-green.svg";
import { Expedition } from "../../../../types";
import { useBoostPercentage } from "../../../../hooks/useBoostPercentage";

type BoostRewardsIndicatorProps = {
	expedition: Expedition;
	employeesCount: number;
};

const BoostRewardsIndicator: React.FC<BoostRewardsIndicatorProps> = ({
	expedition,
	employeesCount,
}) => {
	const { firstProgressBarWidth, secondProgressBarWidth } = useBoostPercentage(
		expedition,
		employeesCount
	);

	return (
		<div className={styles.body}>
			<img
				width={30}
				height={30}
				src={
					firstProgressBarWidth === 100 || secondProgressBarWidth > 0
						? boost_x1_green
						: firstProgressBarWidth > 0
						? boost_x1_orange
						: boost_x1_gray
				}
				style={{
					transform: "scale(0.93)",
					transformOrigin: "50% 100%",
				}}
			/>

			<div className={styles.progressBarContainer}>
				<div
					className={styles.progressFirst}
					style={{
						width: `${firstProgressBarWidth}%`,
						background:
							firstProgressBarWidth === 100 || secondProgressBarWidth
								? "linear-gradient(180deg, #C7F86E 0%, #6EA027 100%)"
								: "linear-gradient(180deg, #ffc62b 0%, #ffa011 100%)",
					}}
				/>
			</div>

			<img
				src={
					firstProgressBarWidth !== 100
						? boost_x1point5gray
						: firstProgressBarWidth === 100 || secondProgressBarWidth > 0
						? boost_x1point5_green
						: boost_x1point5_orange
				}
			/>

			<div
				className={`${styles.progressBarContainer} ${styles.progressBarSecond}`}
			>
				<div
					className={styles.progressSecond}
					style={{
						width: `${secondProgressBarWidth}%`,
						background: secondProgressBarWidth
							? "linear-gradient(180deg, #C7F86E 0%, #6EA027 100%)"
							: "",
					}}
				></div>
			</div>

			<img
				src={secondProgressBarWidth >= 100 ? boost_x2_green : boost_x2_gray}
			/>
		</div>
	);
};

export { BoostRewardsIndicator };
